import { Types } from "../actions/ShiftActions";

const initialState = {
    shiftList: {}
};

export const ShiftReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_SHIFTS:
            return {
                ...state,
                shiftList: action.payload,
            };
        default:
            return state;
    }
}